import { API_URL } from 'constants/runtime';
import { persist } from 'zustand/middleware';
import { createWithEqualityFn as create } from 'zustand/traditional';

interface AppState {
    apiUrl: string;
    setApiUrl: (url: string) => void;
    devLdUrl?: string;
    setDevLdUrl: (url: string) => void;
}

const useAppState = create<AppState>()(
    persist(
        set => ({
            apiUrl: API_URL,
            setApiUrl: apiUrl => set({ apiUrl }),
            devLdUrl: import.meta.env.VITE_DASHBOARD_LAUNCH_DARKLY_LOCAL_URI,
            setDevLdUrl: devLdUrl => set({ devLdUrl }),
        }),
        {
            name: 'givebutter-app-state',
        },
    ),
);

export { useAppState };
export type { AppState };
